export default __webpack_public_path__ + "677b4761a3f4d448cd12c4c3367f248e.png";